import application_settings from '../applicationSettings';
import Event from './Event';

class UserForgotPassword extends Event {
  eventName = "oms_userForgotPassword";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for User login
   *
   * @param {string} data.email -  username of the customer
   * @param {string} data.redirect_url -  redirect url
   * @return void
   *
   */
  eventFunction(data) {
    let clientId = data.client_id;
    let email = data.email;
    let redirectUrl = data.redirect_url;

    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";

    // request data
    data.endPoint = application_settings.endPoints.userForgotPassword;
    data.method = 'POST';
    data.canUsePublicAuth = false;
    data.data = {
      client_id: clientId,
      email: email,
      redirect_url: redirectUrl,
    };

    // send request
    this.sendRequest(data, function (response) {
      if (response) {
        //format response data
        let data = thisObj.formatResponseData(response);

        //fire success event
        thisObj.onSuccessEvent(data, { action: action, request_id: requestId });
      }
    });
  }

  formatResponseData(data) {
    let returnData = [];
    try {
      if (Object.keys(data).length > 0 && Object.keys(data.data).length > 0) {
        returnData = {
          auth_type: data.authType ? data.authType : null,
          logout: data.logout ? data.logout : null,
          client_id: data.client_id ? data.client_id : null,
          success: data.data.status ? data.data.status : false,
          message: data.data.message ? data.data.message : null,
          data: data.data.data ? data.data.data : null,
          total: data.data.total ? data.data.total : null,
        };
      }
    } catch (error) {
      console.log(error);
    }

    return returnData;
  }
}

export default UserForgotPassword;